import React, { useState } from "react";
import { Input, Select, Form, DatePicker } from "antd";
import "./InputGroup.scss";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import EmailInput from "../EmailInput";

const { Option } = Select;

export default function InputGroup({
  inputAry,
  formAry,
  getValue,
  defaultDate,
  ...otherProps
}) {
  let navigate = useNavigate();
  const [selectCity, setSelectCity] = useState("");
  const [selectDistricts, setSelectDistricts] = useState("");
  const handleCityChange = (value) => {
    inputAry.forEach((item) => {
      const { options } = item;
      if (options !== undefined) {
        options.map((city) => {
          if (value === city.name) {
            setSelectCity(city.name);
            setSelectDistricts(city.districts);
          }
          return true;
        });
      }
    });
  };
  const groupItem = inputAry.map((item) => {
    const { options } = item;
    switch (item.type) {
      case "select":
        return (
          <div className="select-wrapper">
            <span className="ant-input-prefix select-title">{item.title}</span>
            <Form.Item name={item.formData.name} rules={item.formData.rules}>
              <Select
                className="input__group-select"
                placeholder={item.placeholder}
              >
                {options.map((optionItem) => {
                  return (
                    <Option value={optionItem.value}>
                      {optionItem.optionName}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </div>
        );

      case "recommend":
        return (
          <div className="select-wrapper">
            <span className="ant-input-prefix select-title">{item.title}</span>
            <Form.Item name={item.formData.name} rules={item.formData.rules}>
              <Select
                className="input__group-select"
                placeholder={item.placeholder}
                onClick={() => {
                  getValue();
                  navigate("/recommend");
                }}
              ></Select>
            </Form.Item>
          </div>
        );

      case "selectRegion":
        return (
          <>
            <div className="select-wrapper">
              <span className="ant-input-prefix select-title">
                通訊地址-縣市
              </span>
              <Form.Item name={item.formData.name} rules={item.formData.rules}>
                <Select
                  className="input__group-select"
                  placeholder={item.placeholder}
                  onChange={handleCityChange}
                  defaultValue={selectCity}
                >
                  {options.map((city) => (
                    <Option key={city.name} value={city.name}>
                      {city.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="select-wrapper">
              <span className="ant-input-prefix select-title">
                通訊地址-地區
              </span>
              <Form.Item
                name="district"
                // rules={[{ required: true, message: "姓名為必填" }]}
              >
                <Select
                  className="input__group-select"
                  placeholder={item.placeholder}
                  defaultValue={selectDistricts[0]}
                  // style={{ width: "50vw" }}
                >
                  {selectDistricts !== "" &&
                    selectDistricts.map((districts) => (
                      <Option key={districts} value={districts}>
                        {districts}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </div>
          </>
        );

      case "input":
        if(item.formData.name === 'email'){
          const { formData, title, placeholder } = item;
          return <EmailInput
          inputName={formData.name}
          inputTitle={title}
          inputPlaceholder={placeholder}
          inputRules={formData.rules}
          required={otherProps?.requiredEmail}
          setRequiredEmail={otherProps?.setRequiredEmail}
          ></EmailInput>
        } else {
          return (
            <Form.Item name={item.formData.name} rules={item.formData.rules}>
              <Input
                prefix={item.title}
                className="input__group-text"
                placeholder={item.placeholder}
              />
            </Form.Item>
          );
        }

      case "shadow":
        return (
          <Form.Item name={item.formData.name} rules={item.formData.rules}>
            <Input.Password
              prefix={item.title}
              className="input__group-text"
              placeholder={item.placeholder}
            />
          </Form.Item>
        );

      case "date":
        const chooseBeforeDay = moment().add(-12, "years");
        return (
          <div className="date-wrapper">
            <span className="ant-input-prefix date-title">{item.title}</span>
            <Form.Item name={item.formData.name} rules={item.formData.rules}>
              <DatePicker
                {...otherProps}
                defaultPickerValue={chooseBeforeDay}
                prefix={item.title}
                className="input__group-date"
                placeholder={item.placeholder}
                disabledDate={(current) => chooseBeforeDay.isBefore(current)}
              />
            </Form.Item>
          </div>
        );

      default:
        return (
          <Form.Item name={item.formData.name} rules={item.formData.rules}>
            <Input
              prefix={item.title}
              className="input__group-text"
              placeholder={item.placeholder}
            />
          </Form.Item>
        );
    }
  });
  return <div className="group-wrapper">{groupItem}</div>;
}
